<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Cadastrar Caderno de Propostas</h1>
          <br>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Título:">
                <b-input-group class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="Título" autocomplete="titulo"
                    v-model="$v.form.titulo.$model" :state="chkState('titulo')" maxlength="130" autofocus />
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group label="Cor do bloco de apresentação:"
                invalid-feedback='É obrigatório informar a cor do bloco de apresentação.'>
                <input type="color" v-model.trim="$v.form.cor_bloco.$model" :state="chkState('cor_bloco')">
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Tipo de Caderno:">
                <b-form-checkbox-group v-model="form.acao_proposta">
                  <b-form-checkbox value="S">Sugestão de edição</b-form-checkbox><br>
                  <b-form-checkbox value="A">Votação</b-form-checkbox><br>
                  <b-form-checkbox value="P">Priorização</b-form-checkbox><br>
                  <b-form-checkbox value="E">Votar Emenda</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Quantidade máxima de priorização no caderno"
                invalid-feedback='É obrigatório informar a quantidade máxima de priorização no caderno.'>
                <b-form-select v-model="form.priorizar_max" :state="chkState('cor_bloco')" placeholder="" class="mb-3">
                  <option selected :value="null"> Selecione</option>
                  <option v-for="i in priorizacao_numero" :key="i" :value="i"> {{ i }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Descrição:" :state="chkState('descricao')">
                <vue-editor v-model="$v.form.descricao.$model" :state="chkState('descricao')" />
                <b-form-invalid-feedback :state="chkState('descricao')" id="input1LiveFeedback9">Este é um campo
                  obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4" style="padding-bottom: 5px;">
              <b-button variant="primary" v-on:click="adicionarProposta()">
                Adicionar Proposta
              </b-button>
            </b-col>
            
            <b-col sm="12" md="4">
              <b-button variant="primary" v-on:click="chamarModalPropostasVinculadas()">
                Agrupar proposta
              </b-button>
            </b-col>
          </b-row>
          <b-row v-for="(proposta, index) in form.propostas" :key="proposta.id" style="margin-top: 10px">
            <b-col cols="12">
              <b-row>
                <b-col cols="8"></b-col>
                <b-col cols="4">
                  <b-button variant="danger" title="Remover" v-on:click="removerProposta(index)" style="float: right; margin-left: 10px; margin-bottom: 1%;">
                    <i class="fa fa-minus"></i>
                  </b-button>
                  <b-button variant="info" title="Adicionar" v-on:click="adicionarProposta()" style="float: right; margin-left: 10px;">
                    <i class="fa fa-plus"></i>
                  </b-button>
                  <b-button variant="secondary" title="Descer" v-if="index < form.propostas.length - 1"
                    v-on:click="moverProposta(index, index + 1)" style="float: right; margin-left: 10px;">
                    <i class="fa fa-arrow-down"></i>
                  </b-button>
                  <b-button variant="secondary" title="Subir" v-if="index > 0" v-on:click="moverProposta(index, index - 1)"
                    style="float: right;">
                    <i class="fa fa-arrow-up"></i>
                  </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <vue-editor v-model="proposta.texto" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-for="(emenda, indexEmenda) in proposta.emendas" :key="emenda.id" style="margin-top: 10px" cols="12">
                  <b-form-group>
                    <b-form-textarea v-model="emenda.texto" rows="6" max-rows="10"></b-form-textarea>
                  </b-form-group>
                  <b-button variant="info" title="Adicionar" v-on:click="adicionarEmenda(index)">
                    <i class="fa fa-plus"></i>
                  </b-button>
                  <b-button variant="danger" title="Remover" v-on:click="removerEmenda(index, indexEmenda)">
                    <i class="fa fa-minus"></i>
                  </b-button>
                </b-col>
                <b-col v-if="proposta.emendas.length == 0" cols="2">
                  <b-button variant="info" title="Adicionar" v-on:click="adicionarEmenda(index)">
                    <i class="fa fa-plus"></i>
                  </b-button>
                </b-col>
              </b-row><br>
              <b-row>
                <b-col cols="4">
                  <b-button variant="primary" v-on:click="adicionarProposta()">
                    Adicionar Proposta
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row><br>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Selecione o Perfil e Ações:">
              </b-form-group>
            </b-col>
            <b-col v-for="perfil in perfis" :key="perfil.value" sm="3">
              <b-form-checkbox class='check' :value="perfil.value" v-model="check_perfil[perfil.value]">
                {{ perfil.text }}</b-form-checkbox>

              <b-form-checkbox-group v-model="form.perfil_id[perfil.value]" v-for="acoes in sub_acoes" :key="acoes.value">

                <b-form-checkbox
                  :disabled="check_perfil[perfil.value] == undefined || check_perfil[perfil.value] == false"
                  class='groupCheck' :value="acoes.value">{{ acoes.text }}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-col>
          </b-row><br>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group>
                <b-form-checkbox v-model="check_formularios">Essa proposta tem condicionamento com respostas da
                  inscrição</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Formulários" invalid-feedback='É obrigatório informar o formulário.'>
                <b-form-select :disabled="disable_formularios" v-model.trim="$v.form.formulario.$model"
                  :state="chkState('formulario')" placeholder="" class="mb-3" :options='options_formularios'>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4">
              <b-button variant="primary" v-on:click="adicionarPerguntaResposta()" :disabled="disable_formularios">
                Adicionar
              </b-button>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="12">
              <span>
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                  class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col" tabindex="0" style="width: 40%">Formulário</th>
                      <th scope="col" tabindex="0" style="width: 20%">Pergunta</th>
                      <th scope="col" tabindex="0" style="width: 20%">Resposta</th>
                      <th scope="col" tabindex="0" style="width: 10%">Perfil</th>
                      <th scope="col" tabindex="0" style="width: 10%">Ações da proposta</th>
                      <th scope="col" tabindex="0" style="width: 20%">Ações</th>
                    </tr>
                  </thead>
                  <tbody v-if="form.propostas_perguntas.length > 0">
                    <tr v-for="(proposta_pergunta, index) in form.propostas_perguntas" :key="proposta_pergunta.id"
                      class="action">
                      <td tabindex="0">
                        {{ proposta_pergunta.formulario_nome }}
                      </td>
                      <td>
                        <b-form-select @change="getRespostas($event, index)"
                          v-model="proposta_pergunta.perguntas_selecionadas" class="mb-3">
                          <option selected :value="null">Selecione</option>
                          <option v-for="pergunta in proposta_pergunta.perguntas" :key="pergunta.id" :value="pergunta.id">
                            {{ pergunta.titulo }}</option>
                        </b-form-select>
                      </td>
                      <td>
                        <b-form-select v-model="proposta_pergunta.alternativas_selecionadas" class="mb-3">
                          <option selected :value="null">Selecione</option>
                          <option v-for="alternativa in proposta_pergunta.respostas" :key="alternativa.id"
                            :value="alternativa.id">{{ alternativa.resposta }}</option>
                        </b-form-select>
                      </td>
                      <td style="width: 35%">
                        <multiselect :options="perfis" v-model="proposta_pergunta.perfis_table" label="text"
                          track-by="value" placeholder="Selecione" selectLabel="" deselectLabel="" selectedLabel=""
                          :tagglabe="true" :multiple="true">
                          <span slot="maxElements"></span>
                          <span slot="noResult">Nenhum encontrado</span>
                          <span slot="noOptions">Lista vazia</span>
                        </multiselect>
                      </td>
                      <td style="width: 35%">
                        <multiselect :options="sub_acoes" v-model="proposta_pergunta.acoes_table" label="text"
                          track-by="value" placeholder="Selecione" selectLabel="" deselectLabel="" selectedLabel=""
                          :tagglabe="true" :multiple="true">
                          <span slot="maxElements"></span>
                          <span slot="noResult">Nenhum encontrado</span>
                          <span slot="noOptions">Lista vazia</span>
                        </multiselect>
                      </td>
                      <td style="width: 8%">
                        <b-button tabindex="0" class="btn btn-sm btn-secondary action" @click="removerPergunta(index)">
                          <i class="fa fa-minus"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="6" tabindex="0">Nenhum pergunta para o formulário</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" md="3">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>Criar Caderno</span>
            </b-button>
          </b-col>
          <b-col v-else md="3">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/proposta')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
      <b-modal id="modalPropostasVinculadas" title="Propostas Vinculadas" v-model="modalPropostasVinculadas"
        :hide-footer="true">
        <b-col cols="12">
          <b-form-group label="Selecione a proposta que deseja víncular: ">
            <multiselect v-model="proposta_vinculada" :options="options_propostas_vinculadas" placeholder="Selecione"
              label="text" track-by="text"></multiselect>
          </b-form-group>
        </b-col>
        <b-card-footer class="p-12">
          <b-row>
            <b-col md="6">
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" @click="fecharModalPropostasVinculadas()">
                <span>Cancelar</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="primary" @click="vincularProposta()">
                <span>Vincular</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-modal>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'
import { VueEditor } from "vue2-editor";

Vue.component('multiselect', Multiselect)

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect,
    VueEditor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      },
      cor_bloco: {
        required
      },
      formulario: {
        required: requiredIf(function () {
          return this.check_formularios
        })
      }
    }
  },
  mounted() {
    this.carregarPerfis()
    this.carregarFormularios()
  },
  created() {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
  },
  data() {
    return {
      loading: false,
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      form: {
        titulo: '',
        descricao: '',
        cor_bloco: '#B0B0B0',
        acao_proposta: [],
        propostas: [],
        propostas_perguntas: [],
        perfil_id: [],
        acoes_perfil: [],
        formulario: null,
        priorizar_max: null,
        emendas: []
      },
      options_formularios: [{ value: null, text: 'Selecione' }],
      options_propostas_vinculadas: [],
      titulo_toast: 'Alerta!',
      perfis: [],
      check_perfil: [],
      sub_acoes: [],
      acao_atualizada: [],
      perguntas: [],
      proposta_vinculada: null,
      priorizacao_numero: 50,
      salvarForm: false,
      check_formularios: false,
      disable_buttons: false,
      disable_formularios: true,
      modalPropostasVinculadas: false
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isValidSelection() {
      return this.selected !== '' && this.selected !== 'forbidden value'
    },
    formularios() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
  },
  watch: {
    'form.acao_proposta': function () {
      this.atualizarAcoesPerfil()
    },
    'check_formularios': function () {
      this.form.propostas_perguntas = []

      if (!this.check_formularios) {
        this.disable_formularios = true
        this.form.formulario = null
      } else {
        this.disable_formularios = false
      }
    }
  },
  methods: {
    validaPerfil() {
      let perfil = this.$store.state.perfil.perfil
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    adicionarProposta() {
      this.form.propostas.push({
        id: null,
        texto: '',
        emendas: []
      })
    },
    adicionarPergunta() {
      this.form.propostas_perguntas.push({
        id: null,
        perguntas_selecionadas: [],
        alternativas_selecionadas: [],
        perfis_table: [],
        acoes_table: []
      })
    },
    adicionarEmenda(index) {
      this.form.propostas[index].emendas.push({
        id: null,
        texto: ''
      })
    },
    removerPergunta(key) {
      this.form.propostas_perguntas.splice(key, 1)
    },
    getRespostas(event, index) {
      this.form.propostas_perguntas[index].respostas.splice(index, 0)
      this.form.propostas_perguntas[index].respostas = this.form.propostas_perguntas[index].perguntas[event]['opcoes_perguntas_dependentes']
    },
    atualizarAcoesPerfil() {
      let content
      let removido
      let list = []
      let ultimasAcoes = this.form.acao_proposta

      if (this.acao_atualizada.length > 0) {
        this.acao_atualizada.forEach(function (element) {
          if (ultimasAcoes.indexOf(element) == -1) {
            removido = element
          }
        });
      }
      this.acao_atualizada = this.form.acao_proposta
      $.each(this.form.acao_proposta, function (key, value) {
        switch (value) {
          case 'S':
            content = { value: 'S', text: 'Sugestão de edição' }
            list.push(content);
            break;
          case 'A':
            content = { value: 'A', text: 'Votação' }
            list.push(content);
            break;
          case 'P':
            content = { value: 'P', text: 'Priorização' }
            list.push(content);
            break;
          case 'E':
            content = { value: 'E', text: 'Votar Emenda' }
            list.push(content);
            break;
        }
      });
      this.sub_acoes = list

      if (removido) {
        this.reordenarListaAcoes(removido)
      }
    },
    reordenarListaAcoes(removido) {
      let perfis_selecionados = this.form.perfil_id
      for (let index in perfis_selecionados) {
        for (let key in perfis_selecionados[index]) {
          if (perfis_selecionados[index][key].indexOf(removido) > -1) {
            perfis_selecionados[index].splice(key, 1)
          }
        }
      }
    },
    removerProposta(key) {
      this.form.propostas.splice(key, 1)
    },
    removerEmenda(index, indexEmenda) {
      this.form.propostas[index].emendas.splice(indexEmenda, 1)
    },
    carregarFormularios() {
      Vue.http.get('api/formulario/relacionados/' + true).then(response => {
        if (response.body.success) {
          let formularios = response.body.data
          for (let i = 0; i < formularios.length; i++) {
            this.options_formularios.push({ value: formularios[i].formulario_servico_id, text: formularios[i].titulo })
          }
        }
      })
    },
    adicionarPerguntaResposta() {
      let formulario = ''
      for (let i in this.options_formularios) {
        if (this.options_formularios[i].value === this.form.formulario) {
          formulario = this.options_formularios[i].text
        }
      }

      if (this.form.formulario) {
        Vue.http.get('api/formulario/buscarPerguntasRespostas/' + this.form.formulario).then(response => {
          if (response.body.success) {
            if (response.body.data.dados) {
              this.form.propostas_perguntas.push({
                id: null,
                formulario_id: this.form.formulario,
                formulario_nome: formulario,
                perguntas_selecionadas: [],
                alternativas_selecionadas: [],
                perfis_table: [],
                acoes_table: [],
                perguntas: response.body.data.dados,
                respostas: []
              })
            }
          }
        })
      }
    },
    moverProposta(oldIndex, newIndex) {
      while (oldIndex < 0) {
        oldIndex += this.form.propostas.length
      }
      while (newIndex < 0) {
        newIndex += this.form.propostas.length
      }
      if (newIndex >= this.form.propostas.length) {
        var k = newIndex - this.form.propostas.length
        while ((k--) + 1) {
          this.form.propostas.push(undefined)
        }
      }
      this.form.propostas.splice(newIndex, 0, this.form.propostas.splice(oldIndex, 1)[0])
      return this.form.propostas
    },
    carregarPerfis() {
      Vue.http.post('api/perfil/index', { status: true }).then(response => {
        if (response.body.success) {
          let perfis = response.body.data

          for (let i = 0; i < perfis.length; i++) {
            this.perfis.push({ value: perfis[i].id, text: perfis[i].nome })
          }
        }
      })
    },
    chamarModalPropostasVinculadas() {
      this.options_propostas_vinculadas = []
      this.proposta_vinculada = null

      Vue.http.get('api/proposta/relacionadas').then(response => {
        if (response.body.success) {
          let propostas = response.body.data

          if (propostas.length > 0) {
            for (let i = 0; i < propostas.length; i++) {
              this.options_propostas_vinculadas.push({ value: propostas[i].id, text: propostas[i].titulo })
            }
            this.modalPropostasVinculadas = true
          } else {
            miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
            miniToastr.error('Não existe proposta a ser vinculada!', 'Alerta', 5000)
          }
        }
      })
    },
    vincularProposta() {
      if (!this.proposta_vinculada) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Selecione uma proposta!', 'Alerta', 5000)
        return false
      }

      this.fecharModalPropostasVinculadas()

      Vue.http.get('api/proposta/' + this.proposta_vinculada.value).then(response => {
        let data = response.body.data
        for (let i = 0; i < data.propostas.length; i++) {
          this.form.propostas.push({
            id: null,
            texto: data.propostas[i].texto
          })
        }
      })
    },
    fecharModalPropostasVinculadas() {
      this.modalPropostasVinculadas = false
    },
    salvar() {
      let form = this.$v.form

      var acao_editar = false;
      var acao_aprovar = false;
      var acao_priorizar = false;
      var acao_emenda = false;

      if (this.form.acao_proposta.length > 0) {
        for (let i = 0; i < this.form.acao_proposta.length; i++) {
          switch (this.form.acao_proposta[i]) {
            case 'S':
              acao_editar = true
              break;
            case 'A':
              acao_aprovar = true
              break;
            case 'P':
              acao_priorizar = true
              break;
            case 'E':
              acao_emenda = true
              break;
          }
        }
      }

      if (this.form.propostas.length == 0) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Adicione ao menos uma proposta!', 'Alerta', 5000)
        return false
      }

      for (let i = 0; i < this.form.propostas.length; i++) {
        if (this.form.propostas[i].texto == "") {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error('Adicione o texto da proposta!', 'Alerta', 5000)
          return false
        }
      }

      let data = {
        titulo: form.titulo.$model,
        cor_bloco: form.cor_bloco.$model,
        descricao: form.descricao.$model,
        formulario_id: form.formulario.$model,
        propostas: this.form.propostas,
        emendas: this.form.emendas,
        cadernos_propostas_acoes: this.form.propostas_perguntas,
        perfil_acoes: this.form.perfil_id,
        acoes_formulario: this.form.acao_proposta,
        acao_editar: acao_editar,
        acao_aprovar: acao_aprovar,
        acao_priorizar: acao_priorizar,
        acao_emenda: acao_emenda,
        conferencia_id: this.conferencia_id,
        priorizar_max: this.form.priorizar_max
      }

      this.loading = true

      Vue.http.post('api/proposta', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({ path: '/proposta' })
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        if (e.data.errors.propostas[0]) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(e.data.errors.propostas[0], 'Alerta', 5000)
        }
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar() {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit() {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState(val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.groupCheck {
  margin-left: 16px;
}

.check {
  margin-top: 8px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/site/interna/caderno/PropostaCadastrar.vue